import styled from "styled-components/macro";

export const DropContainer = styled.div`
  @keyframes bounce {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: var(--menu-color);
  height: 100%;
  width: 100%;
  z-index: 10000;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--grey-1);
  font-size: 20px;
  animation: bounce 0.15s ease-in-out;

  div {
    border: 3px dashed var(--grey-2);
    height: calc(100% - 25px);
    width: calc(100% - 25px);
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      /* margin: 1rem; */
      line-height: 100%;
    }
  }
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  width: 165px;
`;

export const StyledContainer = styled.div`
  height: 100%;
  overflow-y: hidden;
  overscroll-behavior: contain;
  position: relative;

  .title {
    font-size: 1.2rem;
    color: #777;
    margin-bottom: 0.2rem;
  }

  .spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;
  }

  textarea.editable {
    border: 0;
    margin: 0;
    padding: 0;
    font-size: 1.2rem;
    font-family: Inter;
    width: 100%;
    text-align: left;
    display: block;
    text-align: left;
    outline: none;
    line-height: 1.5em;
    resize: none;
    background: var(--menu-color);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    color: var(--icon-button-fill);

    &:disabled {
      background: none;
    }
  }

  &.editing {
    overflow-y: scroll;

    textarea.editable {
      cursor: text;
    }
  }

  &.generating {
    textarea.editable,
    .title {
      opacity: 0.25;
    }
  }
`;
